import { ILinkProps, P2GLink } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';
import { useMemo } from 'react';
import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { ItemContentsMobile } from './ItemContents';
import { ItemRecipientMobile } from './ItemRecipient';
import { P2GBox } from '@parcel2go/core-ui';
import { P2GAlert } from '@parcel2go/core-ui';
import { P2GCheckBoxLegacy } from '@parcel2go/core-ui';
import { P2GLinkGroup } from '@parcel2go/core-ui';
import SmartSendItemInactiveDrop from './SmartSendItemInactiveDrop';
import { GetCollatedCustomerReferenceNumbers } from './OrderReferenceNumberUtils';
import { Truncate } from '../Truncate';
import ECommerceLogo from '~/apps/account-linking/components/ECommerceLogo';

interface props {
  item: SmartSendItemApiModel;
  toggleSelect: (val: boolean) => void;
  restore: (select: boolean) => void;
  deleteItem: () => void;
  removeTag: (tag: string) => void;
  saveTags: (tags: string[]) => void;
  isReturn: boolean;
}

export default function SmartSendItemInactiveMobile(props: props) {
  const refs = GetCollatedCustomerReferenceNumbers(props.item.MarketplaceOrderLines);
  const sourceId = props.item.MarketplaceOrderLines?.[0]?.Source?.Id;

  const links = useMemo(() => {
    const output: ILinkProps[] = [
      <P2GLink key="restore" onClick={() => props.restore(props.item.State.selected)}>
        Include
      </P2GLink>
    ];
    if (!props.item.State.selected) {
      output.push(
        <P2GLink key="include" onClick={() => props.restore(true)}>
          Include and Select
        </P2GLink>
      );
    }
    return output;
  }, [props.item.State.selected, props.restore]);

  return (
    <P2GBox p={1}>
      <P2GBox p={1} display="flex" gap={1} flexDirection="row" alignItems="center" justifyContent="space-between">
        {sourceId && <ECommerceLogo integration={sourceId} style={{ width: '80px' }} />}
        <P2GText variant="subtitle2" component="div" flexGrow={1}>
          <Truncate>{refs}</Truncate>
        </P2GText>
        <P2GCheckBoxLegacy
          labelPlacement="start"
          id="Chk"
          onChange={props.toggleSelect}
          checked={props.item.State.selected}
          label={null}
          variant="primary"
          error={false}
        />
      </P2GBox>
      <P2GBox p={1} backgroundColour="#f1f1f1">
        <ItemRecipientMobile customer={props.isReturn ? props.item.Sender : props.item.Recipient} variant="body2" />
      </P2GBox>
      <P2GBox p={1}>
        <ItemContentsMobile item={props.item} variant="body2" />
      </P2GBox>
      <P2GBox p={1}>
        <P2GAlert color="info">
          <P2GText variant="body2">This item has been saved for later. Do you want to include it again?</P2GText>
          <P2GLinkGroup pb={0} pt={0} links={links} />
        </P2GAlert>
      </P2GBox>
      <P2GBox p={1}>
        <SmartSendItemInactiveDrop deleteItem={props.deleteItem} restore={props.restore} direction="row" />
      </P2GBox>
    </P2GBox>
  );
}
